import React, { useContext, useEffect, useState } from "react";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Button from "@/components/Form/Button/Button";
import "./FormModal.scss";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import {
  useCreateCalculationSettingMutation,
  useGetCalculationStepSummaryApiDataQuery,
  useUpdateCalculationSettingMutation,
} from "../calculationStepReducer";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { isNumericOrNull } from "@/utility/validation";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
//import { useCreateCalculationSettingsMutation } from "../calculationStepReducer";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { useDispatch } from "react-redux";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { DistributionStepContext } from "../../summery/DistributionContext";
type Props = {
  createShow: boolean;
  setCreateShow: React.Dispatch<React.SetStateAction<boolean>>;
  caseId: string;
  stepId: string;
  refetch: any;
  editId: any;
};

export default function FormModalCalculationSetting({
  setCreateShow,
  caseId,
  stepId,
  refetch,
  editId,
}: Props) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const { data: calcSetting } = useGetCalculationStepSummaryApiDataQuery(
    editId,
    { skip: !editId }
  );
  const {
    handleSubmit,
    control,
    setValue,
    setError,
    reset,
    formState: { errors, isDirty },
  } = useForm<any>();
  const [createCalculationSetting] = useCreateCalculationSettingMutation();
  const [updateCalculationSetting] = useUpdateCalculationSettingMutation();

  const setFormat = (value: any) => {
    return value === "" || value == null || value === 0 ? null : Number(value);
  };
  const onSubmit = async (data: any) => {
    const capAmountSmallerError = Number(data?.capAmount) <= Number(data?.floorAmount) ;
    if (capAmountSmallerError && data?.capAmount && data?.floorAmount)  {
      setError("capAmount", {
        type: "manual",
        message: "greater",
      });
      return;
    }
    let formData = {
      caseId: caseId,
      calculationStepId: stepId,
      capAmount: setFormat(data?.capAmount),
      floorAmount: setFormat(data?.floorAmount),
    };
    let editFormData = {
      id: editId,
      capAmount: setFormat(data?.capAmount),
      floorAmount: setFormat(data?.floorAmount),
    };
    setIsLoading(true);
    if (editId !== "") {
      const response = await updateCalculationSetting(editFormData);
      if (response.hasOwnProperty("data")) {
        setCreateShow(false);
        setIsLoading(false);
        refetch();
      } else {
        //@ts-ignore
        const error = response.error?.data?.message || t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
        setIsLoading(false);
      }
    } else {
      const response = await createCalculationSetting(formData);
      if (response.hasOwnProperty("data")) {
        setCreateShow(false);
        setIsLoading(false);
        refetch();
      } else {
        setIsLoading(false);
        //@ts-ignore
        const error = responseApi.error?.data?.message || t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
      }
    }
  };
  const showAmount = (amount: number) => {
    if (calcSetting === undefined) {
      return "";
    }
    return amount === 0 ? "0" : amount;
  };

  useEffect(() => {
    reset({
      capAmount: showAmount(calcSetting?.capAmount),
      floorAmount: showAmount(calcSetting?.floorAmount),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcSetting, setValue]);
  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setCreateShow(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };
          const distributionStepContextData: any = useContext<any>(DistributionStepContext);

    const dispatch = useDispatch();
    useEffect(() => {
      distributionStepContextData.cap_floor_amount(isDirty);

      dispatch(setDiscardEditMode({ editMode: isDirty }));
      return () => {
        distributionStepContextData.cap_floor_amount(false);

        dispatch(setDiscardEditMode({ editMode: false }));
      };
    // eslint-disable-next-line
    }, [dispatch, isDirty]);
  return (
    <>
      {/*@ts-ignore*/}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formModalWrapperCaluclation">
          <div className="formModal">
            {showMessage.show && showMessage.type === "error" && (
              <NotificationGrid
                show={showMessage.show}
                message={showMessage.message}
                type={showMessage.type}
              />
            )}
            <div className="motif-row">
              <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
                <ControlInputBoxNumber
                  name={"capAmount"}
                  // @ts-ignore
                  control={control}
                  required={false}
                  isTextArea={false}
                  label={
                    "pages.distributions.distributionStepsTab.cap_Floor_AmountTab.formLabels.capAmount"
                  }
                  showLabel={true}
                  isNumber={false}
                  digitAfterDecimal={8}
                  isAmount={true}
                  onChangeAmount={() => {}}
                  validate={isNumericOrNull}
                  // validate={isNumeric}
                />
                {errors["capAmount"]?.message === "greater" && (
                  <MotifErrorMessage>
                    {t(
                      "pages.distributions.distributionStepsTab.cap_Floor_AmountTab.validationMessage.capAmountRequired"
                    )}{" "}
                  </MotifErrorMessage>
                )}
                {errors["capAmount"]?.type === "validate" && (
                  <MotifErrorMessage>
                    {t(
                      "pages.distributions.distributionStepsTab.cap_Floor_AmountTab.validationMessage.capAmountInvalid"
                    )}{" "}
                  </MotifErrorMessage>
                )}
              </div>
              <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
                <ControlInputBoxNumber
                  name={"floorAmount"}
                  // @ts-ignore
                  control={control}
                  required={false}
                  isTextArea={false}
                  label={
                    "pages.distributions.distributionStepsTab.cap_Floor_AmountTab.formLabels.floorAmount"
                  }
                  showLabel={true}
                  isNumber={false}
                  digitAfterDecimal={8}
                  isAmount={true}
                  onChangeAmount={() => {}}
                  validate={isNumericOrNull}
                  // validate={isNumeric}
                />
                {errors["floorAmount"]?.type === "validate" && (
                  <MotifErrorMessage>
                    {t(
                      "pages.distributions.distributionStepsTab.cap_Floor_AmountTab.validationMessage.floorAmountInvalid"
                    )}{" "}
                  </MotifErrorMessage>
                )}
              </div>
            </div>
          </div>
          <div className="button-container-add">
            <Button
              variant={SAVE_BUTTON_VARIANT}
              label={t("global.globalActions.save")}
              loading={isLoading}
              disabled={isLoading}
            />
            <Button
              label={t("global.globalActions.cancel")}
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
              className="cancelBtn"
              onClickHandler={(e) => {
                if (isDirty) {
                  setIsVisibleCancel(true);
                } else {
                  cancelBtnApproveHandler(e);
                }
              }}
            />
          </div>
        </div>
      </form>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
